
import { ShieldCheck, Users, BarChart3, Clock } from "lucide-react";

export const FeatureSection = () => {
  return (
    <div className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-16">
          Kenapa Memilih Jaringan IDN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-white p-6 rounded-xl shadow-sm text-center">
            <div className="w-12 h-12 bg-[#008169] rounded-full flex items-center justify-center mx-auto mb-4">
              <ShieldCheck className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Keamanan Terjamin</h3>
            <p className="text-gray-600">Data pesantren Anda aman dan terlindungi dengan sistem keamanan terkini</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm text-center">
            <div className="w-12 h-12 bg-[#008169] rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Tim Support 24/7</h3>
            <p className="text-gray-600">Dukungan teknis profesional siap membantu Anda kapan saja</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm text-center">
            <div className="w-12 h-12 bg-[#008169] rounded-full flex items-center justify-center mx-auto mb-4">
              <BarChart3 className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Laporan Terperinci</h3>
            <p className="text-gray-600">Analisis data dan laporan detail untuk pengambilan keputusan yang lebih baik</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm text-center">
            <div className="w-12 h-12 bg-[#008169] rounded-full flex items-center justify-center mx-auto mb-4">
              <Clock className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Hemat Waktu</h3>
            <p className="text-gray-600">Otomatisasi tugas administratif untuk efisiensi pengelolaan pesantren</p>
          </div>
        </div>
      </div>
    </div>
  );
};
